
import { Component, Vue, Ref } from 'nuxt-property-decorator';
import { Gradient, GradientOptions } from '~/modules/gradientAnimation';

@Component
export default class GradientAnimation extends Vue {
  @Ref() readonly gradientCanvas?: HTMLCanvasElement;

  gradient: null | Gradient = null;
  colors = ['#7a6fff', '#f2dafb', '#b7c2ff', '#b7c2ff'];
  defaultOptions: GradientOptions = {
    seed: 8,
    scaleY: 1,
    scaleX: 1,
  };

  mounted() {
    this.$nextTick(() => {
      this.gradient = new Gradient(this.gradientCanvas, this.colors, {
        static: false,
        ...this.defaultOptions,
      });
    });
  }
  beforeDestroy() {
    this.gradient?.disconnect();
  }
}
